module.exports = __webpack_public_path__ + "images/emoji/computer.594e061802f4d90c57c4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/computer.png
// module id = vY/5
// module chunks = 13